/* Decottaa teması – son bakılan ürünler (ziyaretçinin tarayıcısında saklanır, hesap gerektirmez). */
(() => {
  const theme = window.theme || {};
  if (!theme.utils) return;
  const { $, parseHTML, syncFavorites } = theme.utils;
  const KEY = 'decottaa:recently-viewed';
  const MAX = 12;

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((handle) => typeof handle === 'string') : [];
    } catch (error) {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (error) {
      /* gizli pencere vb.: kaydedilemezse liste boş kalır */
    }
  };

  // Ürün sayfasında görüntülenen ürünü listenin başına ekle
  const current = document.querySelector('product-info[data-product-handle]');
  if (current && !window.__decottaaRecentSaved) {
    window.__decottaaRecentSaved = true;
    const handle = current.dataset.productHandle;
    write([handle, ...read().filter((item) => item !== handle)]);
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    async render() {
      const limit = Number(this.dataset.limit) || 4;
      const handles = read()
        .filter((handle) => handle !== this.dataset.exclude)
        .slice(0, limit);
      if (!handles.length) return;
      const root = (this.dataset.root || '/').replace(/\/?$/, '/');
      const cards = await Promise.all(
        handles.map(async (handle) => {
          try {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=product-card-ajax`);
            if (!response.ok) return null;
            return $('.product-card', parseHTML(await response.text()));
          } catch (error) {
            return null;
          }
        })
      );
      const valid = cards.filter(Boolean);
      if (!valid.length) return;
      $('[data-recent-grid]', this).replaceChildren(...valid);
      this.hidden = false;
      if (typeof syncFavorites === 'function') syncFavorites(this);
    }
  }
  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
})();
